import React, { useMemo, useState } from 'react';
import { useChipStyles } from './styles';
import ChipInput from 'material-ui-chip-input';
import { useTranslation } from 'react-i18next';

/**
 * Used for all assignment modals
 * @param assignUnassignToRestaurants
 * @constructor
 */
const ShowSelectedRestaurants = ({ values, onUpdate }) => {
  const chipStyles = useChipStyles();

  const [inputValue, setInputValue] = useState('');

  const restaurantChips = useMemo(
    () => values.map(node => node.text),
    [values],
  );

  const handleChipDelete = (item, index) => {
    const valuesList = [...values];
    valuesList.splice(index, 1);
    onUpdate(valuesList)
  };

  const { t } = useTranslation();

  return (

    <ChipInput
      label={t('home.assignment.selectedRestaurants')}
      value={restaurantChips}
      variant="outlined"
      fullWidth
      onDelete={handleChipDelete}
      inputValue={inputValue}
      onUpdateInput={() => setInputValue('')}
      classes={chipStyles}
    />

  );
};

export default ShowSelectedRestaurants;
